// extracted by mini-css-extract-plugin
export default {"tmxEventTypeContainer":"tmx-event-type-container__tmx-event-type-container__AyiYa"};